import { post } from 'aws-amplify/api';
import { PRESCRIPTSURE } from '../constants/api-endpoints';
import { getSessionToken } from './service-config';
const apiNamePath = PRESCRIPTSURE.ANALYTICS_API;

const coverageVerificationAnalyticService = {
  async getCoverageVerificationStats({ organization }) {
    const sessionToken = await getSessionToken();

    const getCoverageVerificationStatsOperation = post({
      apiName: apiNamePath,
      path: '/coverage_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'coverage_stats',
          organization: organization,
        },
      },
    });

    const getCoverageVerificationStatsResults = (
      await getCoverageVerificationStatsOperation.response
    ).body.json();

    return getCoverageVerificationStatsResults;
  },

  async getTopVerifiedDrugs({ organization }) {
    const sessionToken = await getSessionToken();

    const getTopVerifiedDrugsOperation = post({
      apiName: apiNamePath,
      path: '/coverage_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'top_verified_drugs',
          organization: organization,
        },
      },
    });

    const getTopVerifiedDrugsResults = (
      await getTopVerifiedDrugsOperation.response
    ).body.json();

    return getTopVerifiedDrugsResults;
  },

  async getMostActiveProvidersThisWeek({ organization }) {
    const sessionToken = await getSessionToken();

    const getMostActiveProvidersThisWeekOperation = post({
      apiName: apiNamePath,
      path: '/coverage_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'providers_active_this_week',
          organization: organization,
        },
      },
    });

    const getMostActiveProvidersThisWeekResults = (
      await getMostActiveProvidersThisWeekOperation.response
    ).body.json();

    return getMostActiveProvidersThisWeekResults;
  },

  async getActivelyQueriedPlans({ organization }) {
    const sessionToken = await getSessionToken();

    const getActivelyQueriedPlansOperation = post({
      apiName: apiNamePath,
      path: '/coverage_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'plans_queried',
          organization: organization,
        },
      },
    });

    const getActivelyQueriedPlansResults = (
      await getActivelyQueriedPlansOperation.response
    ).body.json();

    return getActivelyQueriedPlansResults;
  },

  async getVerificationsByState({ organization }) {
    const sessionToken = await getSessionToken();

    const getVerificationsByStateOperation = post({
      apiName: apiNamePath,
      path: '/coverage_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'verifications_by_stateid',
          organization: organization,
        },
      },
    });

    const getVerificationsByStateResults = (
      await getVerificationsByStateOperation.response
    ).body.json();

    return getVerificationsByStateResults;
  },

  // ==================== NEW COVERAGE VERIFICATION ANALYTICS ====================

  async getCoverageCheckSuccessRate({ organization, dateRange = '30d' }) {
    const sessionToken = await getSessionToken();

    const operation = post({
      apiName: apiNamePath,
      path: '/coverage_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'coverage_check_success_rate',
          organization: organization,
          date_range: dateRange,
        },
      },
    });

    const results = (await operation.response).body.json();
    return results;
  },

  async getMostPopularPlanDrugCombos({ organization, dateRange = '30d', limit = 20 }) {
    const sessionToken = await getSessionToken();

    const operation = post({
      apiName: apiNamePath,
      path: '/coverage_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'most_popular_plan_drug_combos',
          organization: organization,
          date_range: dateRange,
          limit: limit,
        },
      },
    });

    const results = (await operation.response).body.json();
    return results;
  },

  async getTabEngagementAnalysis({ organization, dateRange = '30d' }) {
    const sessionToken = await getSessionToken();

    const operation = post({
      apiName: apiNamePath,
      path: '/coverage_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'tab_engagement_analysis',
          organization: organization,
          date_range: dateRange,
        },
      },
    });

    const results = (await operation.response).body.json();
    return results;
  },

  async getCoverageOutcomesDistribution({ organization, dateRange = '30d' }) {
    const sessionToken = await getSessionToken();

    const operation = post({
      apiName: apiNamePath,
      path: '/coverage_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'coverage_outcomes_distribution',
          organization: organization,
          date_range: dateRange,
        },
      },
    });

    const results = (await operation.response).body.json();
    return results;
  },

  async getTherapeuticClassAnalysis({ organization, dateRange = '30d', limit = 15 }) {
    const sessionToken = await getSessionToken();

    const operation = post({
      apiName: apiNamePath,
      path: '/coverage_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'therapeutic_class_analysis',
          organization: organization,
          date_range: dateRange,
          limit: limit,
        },
      },
    });

    const results = (await operation.response).body.json();
    return results;
  },

  async getPBMPayerPerformance({ organization, dateRange = '30d' }) {
    const sessionToken = await getSessionToken();

    const operation = post({
      apiName: apiNamePath,
      path: '/coverage_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'pbm_payer_performance',
          organization: organization,
          date_range: dateRange,
        },
      },
    });

    const results = (await operation.response).body.json();
    return results;
  },

  // ==================== END NEW COVERAGE VERIFICATION ANALYTICS ====================

  async getCoverageChecksByRole({ organization, dateRange = '30d' }) {
    const sessionToken = await getSessionToken();

    const operation = post({
      apiName: apiNamePath,
      path: '/coverage_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'coverage_checks_by_role',
          organization: organization,
          date_range: dateRange,
        },
      },
    });

    const results = (await operation.response).body.json();
    return results;
  },

  async getFeatureModuleAdoption({ organization, dateRange = '30d' }) {
    const sessionToken = await getSessionToken();

    const operation = post({
      apiName: apiNamePath,
      path: '/coverage_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'feature_module_adoption',
          organization: organization,
          date_range: dateRange,
        },
      },
    });

    const results = (await operation.response).body.json();
    return results;
  },

  async getAPICallFrequency({ organization, dateRange = '30d' }) {
    const sessionToken = await getSessionToken();

    const operation = post({
      apiName: apiNamePath,
      path: '/coverage_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'api_call_frequency',
          organization: organization,
          date_range: dateRange,
        },
      },
    });

    const results = (await operation.response).body.json();
    return results;
  },
};

export default coverageVerificationAnalyticService;
